module.exports = __webpack_public_path__ + "img/icon_1_12.d2f0048d.png";